import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  root: {
    minWidth: 288,
    cursor: 'pointer',
  },
  icon: {
    display: 'none',
  },
}));
